import React from 'react';
import Loading from '../components/atoms/Loading';
import CustomPagination from '../components/atoms/customPagination';
import ComplaintTableToolbar from '../components/molecules/ComplaintTableToolbar';
import ComplaintTableGrid from '../components/organisms/ComplaintTableGrid';
import useComplaintManagementDetails from '../hooks/useComplaintManagementDetails';

export default function ComplaintManagementDetails() {
  const complaint = useComplaintManagementDetails();

  return (
    <section className="ca-complaint-table" aria-label="Complaint records">
      <ComplaintTableToolbar
        selectedStatus={complaint.selectedStatus}
        statusNames={complaint.statusNames}
        updatedAtSortOldest={complaint.selectedUpdatedAtSort === 'asc'}
        onStatusChange={complaint.onStatusChange}
        onSortChange={complaint.onSortChange}
        onNewComplaint={complaint.onNewComplaint}
        onDownloadReport={complaint.onDownloadReport}
        isDownloadingReport={complaint.isDownloadingReport}
        complaintTypeId={complaint.complaintTypeId}
      />

      {complaint.error ? <p className="ca-body">{complaint.error}</p> : null}
      {complaint.downloadError ? <p className="ca-body">{complaint.downloadError}</p> : null}
      {complaint.statusUpdateError ? (
        <div className="ca-validation-toast" role="alert">{complaint.statusUpdateError}</div>
      ) : null}
      {complaint.showLoading ? (
        <Loading text="Loading complaints" />
      ) : (
        <ComplaintTableGrid {...complaint.tableProps} />
      )}
      {complaint.paginationProps.hasRows ? <CustomPagination {...complaint.paginationProps} /> : null}
    </section>
  );
}
